<template>
  <div>
    <UDashboardSlideover
      v-model="isOpen"
      :ui="{ background: 'rounded-l-lg', width: 'max-w-screen-sm' }"
    >
      <template #header>
        <SlideoverHeader text="Handlekurv" :onClose="() => (isOpen = false)" />
      </template>
      <template #footer>
        <UButton
          color="brand-action"
          class="text-black"
          block
          to="/handlekurv"
          @click="isOpen = false"
          >Fortsett til kassen</UButton
        >
      </template>

      <ShoppingCartDisplay />
    </UDashboardSlideover>
  </div>
</template>

<script setup lang="ts">
import SlideoverHeader from "@/components/shared/SlideoverHeader.vue";

const { $listen } = useNuxtApp();

const isOpen = ref(false);

$listen("open-shopping-cart", () => {
  isOpen.value = true;
});

$listen("close-all-overlays", () => {
  isOpen.value = false;
});
</script>
